import React from 'react';
import { IoPersonOutline, IoShieldOutline, IoDiamondOutline, IoTrendingUpOutline, IoCheckmarkCircleOutline, IoPencilOutline, IoDocumentTextOutline, IoKeyOutline, IoWalletOutline, IoMailOutline, IoIdCardOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AccountContent({ userInfo, isDocsVerified, is2faEnabled }) {
    const { t } = useTranslation();
    return (
        <div className="account-content">
            {/* User Profile Header */}
            <div className="content-header">
                <div className="user-profile">
                    <div className="user-avatar">
                        <IoPersonOutline size={24} />
                    </div>
                    <div className="user-info">
                        <div className="username">
                            {userInfo?.fullName || t('accountContent.user')}
                            {/* <IoPencilOutline size={16} className="edit-icon" /> */}
                        </div>
                        <div className="user-details">
                            <span style={{ fontSize: '13px', fontWeight: 300 }}>{t('accountContent.accountNumber')}: <span className='ms-1' style={{ fontWeight: 500 }}>{userInfo?.userId || '-'}</span></span>
                            <span className="separator">|</span>
                            <span style={{ fontSize: '13px', fontWeight: 300 }}>{t('accountContent.emailAddress')}: <span className='ms-1' style={{ fontWeight: 500 }}>{userInfo?.mail || '-'}</span></span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Two Column Layout for Sections */}
            <div className="account-sections-container">
                {/* User Information Section */}
                <div className="user-info-section">
                    <h3 className="section-title">{t('accountContent.userInformation')}</h3>
                    <div className="content-rows">
                    <div className="content-row">
                        <div className="row-left">
                            <IoPersonOutline size={20} className="row-icon" />
                            <span className="row-label">{t('accountContent.fullName')}</span>
                        </div>
                        <div className="row-right">
                            <span className="row-value">{userInfo?.fullName || 'N/A'}</span>
                        </div>
                    </div>

                    <div className="content-row">
                        <div className="row-left">
                            <IoIdCardOutline size={20} className="row-icon" />
                            <span className="row-label">{t('accountContent.accountNumber')}</span>
                        </div>
                        <div className="row-right">
                            <span className="row-value">{userInfo?.userId || 'N/A'}</span>
                        </div>
                    </div>

                    <div className="content-row">
                        <div className="row-left">
                            <IoMailOutline size={20} className="row-icon" />
                            <span className="row-label">{t('accountContent.email')}</span>
                        </div>
                        <div className="row-right">
                            <span className="row-value">{userInfo?.mail || 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Account Details Section */}
            <div className="account-details-section">
                <h3 className="section-title">{t('accountContent.accountDetails')}</h3>
                <div className="content-rows">
                {/* Kimlik Doğrulama Satırı */}
                <div className="content-row">
                    <div className="row-left">
                        <IoIdCardOutline size={20} className="row-icon" />
                        <span className="row-label">{t('accountContent.identityVerification')}</span>
                    </div>
                    <div className="row-right">
                        <span className={`row-status me-4 ${isDocsVerified ? 'text-success' : ''}`}>{isDocsVerified ? t('accountContent.verified') : t('accountContent.unverified')}</span>
                        <Link to="/documents">
                            <button className="row-btn">{t('accountContent.documents')}</button>
                        </Link>
                    </div>
                </div>

                {/* 2FA Satırı */}
                <div className="content-row">
                    <div className="row-left">
                        <IoKeyOutline size={20} className="row-icon" />
                        <span className="row-label">{t('accountContent.twoFactorAuth')}</span>
                    </div>
                    <div className="row-right">
                        <span className={`row-status me-4 ${is2faEnabled ? 'text-success' : ''}`}>{is2faEnabled ? t('accountContent.active') : t('accountContent.inactive')}</span>
                        <Link to="/two-factor-auth">
                            <button className="row-btn activate-btn">{t('accountContent.activate')}</button>
                        </Link>
                    </div>
                </div>

                {/* Bakiye Satırı */}
                <div className="content-row">
                    <div className="row-left">
                        <IoWalletOutline size={20} className="row-icon" />
                        <span className="row-label">{t('accountContent.balance')}</span>
                    </div>
                    <div className="row-right">
                        <span className={`row-value ${userInfo?.Balance < 0 ? 'negative' : 'positive'}`}>
                            ${userInfo?.Balance ?? '0.00'}
                        </span>
                    </div>
                </div>

                {/* Kredi Satırı */}
                <div className="content-row">
                    <div className="row-left">
                        <IoDiamondOutline size={20} className="row-icon" />
                        <span className="row-label">{t('accountContent.credit')}</span>
                    </div>
                    <div className="row-right">
                        <span className="row-value positive">
                            ${userInfo?.Credit ?? '0.00'}
                        </span>
                    </div>
                </div>
            </div>
            </div>
            </div>
        </div>
    );
}
